// SlotStateIcon — ONE glyph for every "slot" (required document, per-case
// requirement, wizard upload): the same states, spinner and drawn check as the
// comment Acknowledge button (.sbtn), so "done" looks the same everywhere.
//   required  → "!" on a neutral disc
//   uploading → spinner
//   done      → filled disc + drawn check (green — a file is attached)
//   waived    → filled disc + dash (amber — answered with a reason, no document:
//               half done, it still draws the eye; Bootstrap's dash-circle-fill)
export default function SlotStateIcon({ state = 'required' }) {
  const cls = `attach-slot-icon is-${state}`;
  if (state === 'uploading') {
    return <span className={cls} role="img" aria-label="Uploading"><span className="spinner" /></span>;
  }
  if (state === 'done') {
    return (
      <span className={cls} aria-hidden="true">
        <svg className="check" viewBox="0 0 24 24"><path d="M5 13 l4 4 L19 7" /></svg>
      </span>
    );
  }
  if (state === 'waived') {
    return (
      <span className={cls} aria-hidden="true">
        <svg className="dash" viewBox="0 0 24 24"><path d="M6 12 L18 12" /></svg>
      </span>
    );
  }
  return <span className={cls} aria-hidden="true">!</span>;
}
